import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { Controls } from '../../components/controls/Controls';
import { Form, useForm } from '../../components/useForm';

const initialFieldValues = {
    id: 0,
    nombre: '',
    nombreCorto: '',
    codigoBanco: '',
    swiftBic: '',
    pais: '',
    monedaPrincipal: '',
    sitioWeb: '',
    telefono: '',
    direccion: '',
};

export default function BancosForm(props) {
    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm,
        // eslint-disable-next-line no-use-before-define
    } = useForm(initialFieldValues, true, validate);

    function validate(fieldValues = values) {
        const temp = { ...errors };

        if ('nombre' in fieldValues) {
            temp.nombre = fieldValues.nombre ? '' : 'Campo Requerido';
        }
        if ('nombreCorto' in fieldValues) {
            temp.nombreCorto = fieldValues.nombreCorto ? '' : 'Campo Requerido';
        }
        if ('pais' in fieldValues) {
            temp.pais = fieldValues.pais ? '' : 'Campo Requerido';
        }

        setErrors({ ...temp });

        if (fieldValues === values) {
            return Object.values(temp).every((x) => x === '');
        }
        return true;
    }

    const { addOrEdit, recordForEdit } = props;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            addOrEdit(values, resetForm);
        }
    };

    useEffect(() => {
        if (recordForEdit != null) {
            setValues({ ...recordForEdit });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordForEdit]);

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
                <Grid item xs={6}>
                    <Controls.Input
                        error={errors.nombre}
                        label='Nombre'
                        name='nombre'
                        onChange={handleInputChange}
                        value={values.nombre}
                    />
                    <Controls.Input
                        error={errors.nombreCorto}
                        label='Nombre Corto'
                        name='nombreCorto'
                        onChange={handleInputChange}
                        value={values.nombreCorto}
                    />
                    <Controls.Input
                        error={errors.codigoBanco}
                        label='Código Banco'
                        name='codigoBanco'
                        onChange={handleInputChange}
                        value={values.codigoBanco}
                    />
                    <Controls.Input
                        error={errors.swiftBic}
                        label='SWIFT / BIC'
                        name='swiftBic'
                        onChange={handleInputChange}
                        value={values.swiftBic}
                    />
                    <Controls.Input
                        error={errors.pais}
                        label='País'
                        name='pais'
                        onChange={handleInputChange}
                        value={values.pais}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Controls.Input
                        error={errors.monedaPrincipal}
                        label='Moneda Principal'
                        name='monedaPrincipal'
                        onChange={handleInputChange}
                        value={values.monedaPrincipal}
                    />
                    <Controls.Input
                        error={errors.sitioWeb}
                        label='Sitio Web'
                        name='sitioWeb'
                        onChange={handleInputChange}
                        value={values.sitioWeb}
                    />
                    <Controls.Input
                        error={errors.telefono}
                        label='Teléfono'
                        name='telefono'
                        onChange={handleInputChange}
                        value={values.telefono}
                    />
                    <Controls.Input
                        error={errors.direccion}
                        label='Dirección'
                        name='direccion'
                        onChange={handleInputChange}
                        value={values.direccion}
                    />
                    <div>
                        <Controls.Button text='Guardar' type='submit' />
                        <Controls.Button
                            color='default'
                            onClick={resetForm}
                            text='Reset'
                        />
                    </div>
                </Grid>
            </Grid>
        </Form>
    );
}
